import React, { FC } from 'react';
import { Moment } from 'moment';
import { DateInput } from '../../../../components';
import { ClassFiltersColumn } from '../Filters.styles';

export type DatesPickerProps = {
  showDatesPicker?: boolean;
  onDateChange: (props) => void;
  fromDate?: Moment | string;
};

export const DatePicker: FC<DatesPickerProps> = ({
  showDatesPicker = true,
  onDateChange,
  fromDate,
}) =>
  showDatesPicker ? (
    <ClassFiltersColumn>
      <DateInput onDateChange={onDateChange} startDate={fromDate as Moment} />
    </ClassFiltersColumn>
  ) : null;
